import React from 'react'

export const MetaChannelForm = ({ dataItem, onChange }) => {
    return (
        <>
            <div className='col-6 mt-2'>
                <label htmlFor="adAccountId">Account ID *</label>
                <input
                    type="text"
                    name="adAccountId"
                    className='form-control form-control-sm'
                    placeholder="Enter Account ID"
                    value={dataItem.adAccountId}
                    onChange={onChange}
                />
            </div>
            <div className='col-12 mt-2'>
                <label htmlFor="accessToken">Access Token *</label>
                <input
                    type="password"
                    name="accessToken"
                    placeholder="Enter Access Token"
                    className='form-control form-control-sm'
                    value={dataItem.accessToken}
                    onChange={onChange}
                />
                <small className="form-text text-muted">Generate Access Token <a href="https://developers.facebook.com/tools/explorer/" target="_blank" rel="noreferrer">here</a></small>
            </div>
            <div className="col-12 mt-2">
                <label className="fw-bold">How to get your Account ID and Access Token:</label>
                <div className="border rounded overflow-auto" style={{ maxHeight: '250px' }}>
                    <ol className="small ml-3 p-2">
                        <li>
                            <strong>Get your Ad Account ID:</strong>
                            <ul>
                                <li>Go to your <a href="https://business.facebook.com/" target="_blank" rel="noreferrer">Facebook Business Manager</a>.</li>
                                <li>Select your business and go to the "Business Settings".</li>
                                <li>Navigate to "Ad Accounts" under "Accounts".</li>
                                <li>You'll see a list of Ad Accounts. The ID is displayed below the account name.</li>
                            </ul>
                        </li>
                        <li className="mt-2">
                            <strong>Generate an Access Token:</strong>
                            <ul>
                                <li>Visit the <a href="https://developers.facebook.com/tools/explorer/" target="_blank" rel="noreferrer">Graph API Explorer</a>.</li>
                                <li>Select your App from the top-right dropdown.</li>
                                <li>Click on "Get Token" &gt; "Get User Access Token".</li>
                                <li>Select the required permissions (e.g., <code>ads_read</code>, <code>ads_management</code>).</li>
                                <li>Click "Generate Access Token" and copy the token.</li>
                                <li><strong>Note:</strong> Access tokens are temporary. Use a system user token for long-term usage via Facebook App settings.</li>
                            </ul>
                        </li>
                    </ol>
                </div>
            </div>
        </>
    )
}
